module.exports = __webpack_public_path__ + "img/unionpay.2ddf8fbc.png";